import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { PharmaciesDetailsFiltersContext } from '../../../../context/PharmaciesDetailsFiltersContext'
import { formatedProduct, formatNumber } from '../../../../utils/Helpers'
import { ORDER_STATUS } from '../../../../types/Order'

const GET_TOP_ORDERS_PRODUCT = gql`
  query TopOrderProducts ($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                new_status: "${ORDER_STATUS.DELIVERED}"
              }
            }
          ]
        }
      },
      aggs: {
        names: {
          terms: {
            field: "items.name"
          },
          aggs: {
            quantity: {
              sum: {
                field: "items.quantity"
              }
            },
            sales_bucket_sort: {
              bucket_sort: {
                sort: [
                  {
                    quantity: {
                      order: "desc"
                    }
                  }
                ],
                size: 10
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string,
  doc_count: number,
  quantity: any
}
const MoreOrdersProducts = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_TOP_ORDERS_PRODUCT, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const { pharmacies } = filters
    getData({
      variables: { filters: pharmacies }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.aggregation.aggregations) return <p>No data found</p>

  const { buckets } = data.aggregation.aggregations.names
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(formatedProduct(bucket.key))
    return seriesData.push(bucket.quantity.value)
  })

  const options = {
    chart: {
      id: 'top-products-orders-by-pharmacy'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 0, true)
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return formatNumber(value, 0)
        }
      }
    }
  }
  const series = [{
    name: 'Quantidade',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      Produtos mais vendidos
    </Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.cleanBlue} height={340} />
  </Paper>
}

export default MoreOrdersProducts
